import { Box, Button, CircularProgress, Grid, InputAdornment, Stack, TextField } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { useEffect, useRef, useState } from 'react';
import Thermometer from '@/components/Base/Thermometer.tsx';
import { TitlePages } from '@/components/Base/TitlePage';
import { ArrowBack } from '@mui/icons-material';
import KpiComponent from '@/components/Base/KpiComponent';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import Search from '@mui/icons-material/Search';
import { useTermometroFinanceiroAnaliseDescontos } from '@/features/termometro/getTermometroFinanceiroAnaliseDescontos';
import { useNavigate } from 'react-router-dom';
import { useTermometroPedagogico } from '@/features/termometro/getTermometroPedagogico';
import TableTermometroPedagogico from '@/components/Base/TableTermometroPedagogico';

const TermometroPedagogico = () => {
  const [activeTab, setActiveTab] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroPedagogico({
    name: searchQuery || undefined
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && document.activeElement === inputRef.current) {
        setSearchQuery(inputRef.current?.value || '');
        refetch();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [refetch]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const { data: dataAnaliseDescontos } = useTermometroFinanceiroAnaliseDescontos();

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filterData = (data) => {
    return data;
  };

  return (<>
    <Box padding={'15px'}>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack alignItems={'center'} flexDirection={'row'}>
          <ArrowBack sx={{ cursor: 'pointer', mr: '10px' }} />
          <TitlePages title={'Termômetro Pedagógico'} showInterrogation={true} />
        </Stack>
        <Button
          variant="contained"
          sx={{
            borderRadius: '24px',
            fontSize: '14px',
            color: '#fff',
            height: '32px',
            background: '#15AB51',
            fontWeight: '700',
            cursor: 'pointer',
            textTransform: 'capitalize',

            '.MuiButton-text': {
              fontSize: '14px', height: '17px', fontWeight: '700', lineHeight: '17px',

            },
          }}
          onClick={() => navigate('/configuracoes-avancadas-termometro-pedagogico')}
        >
          Configurações avançadas
        </Button>
      </Stack>

      {summary && isFetched && (<Stack flexDirection={'row'} gap={'8px'}>
        <KpiComponent 
          title={'Quantidade de alunos no Score baixo '}
          bgColor="#FFFFFF"
          border={'2px solid #ECEEF7'}
          borderRadius={'6px'}
          value={summary?.total_low_students || '-'} 
          style={{ width: '160px' }}
        />

        <KpiComponent
          title={'Quantidade de alunos no Score Intermediário'}
          bgColor="#FFFFFF"
          border={'2px solid #ECEEF7'}
          value={summary?.total_intermediary_students || '-'}
          style={{ width: '160px' }}
        />
        
        <KpiComponent 
          title={'Quantidade de alunos no Score alto'}
          bgColor="#FFFFFF"
          border={'2px solid #ECEEF7'}
          value={summary?.total_high_students || '-'} 
          style={{ width: '160px' }}
        />
                
        <KpiComponent
          title={'Quantidade de alunos nas Escolinhas'} 
          value={summary?.count_students_without_boletim?.escolinhas || '-'}
          // value={"100"}
          bgColor="#FFFFFF"
        />

        <KpiComponent 
          title={'Termômetro Eduzinho'}
          bgColor="#FFFFFF"
          border={'2px solid #ECEEF7'}
          value={summary?.score || '-'} 
          tooltipText={"O Eduzinho é calculado como a média dos scores pedagógicos de cada aluno ao longo do ano atual."}
          style={{ width: '160px' }}
        />
      </Stack>)}
      {isFetching && !summary && <LoadingSummary />}

      <Box
        sx={{
          background: '#fff', boxShadow: 'none', borderRadius: '8px',
        }} p={'20px'} mt={2} mb={2}
      >
        <Thermometer
          score={summary?.score || 0}
        />
      </Box>

      <TextField
        variant="outlined"
        inputRef={inputRef}
        placeholder="Pesquisar por nome do aluno"
        sx={{
          marginBottom: '15px',
          '.MuiOutlinedInput-root': { borderRadius: '40px', padding: '0 !important' }, // Remove padding
          '.MuiOutlinedInput-input': { padding: '10px' },
          maxWidth: '500px',
          width: '100%',
          backgroundColor: '#FDFDFD',
          borderRadius: '24px',
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{
                p: 0,
                m: 0,
              }}
            >
              <Box
                component="button"
                type="button"
                sx={{
                  border: 'none',
                  outline: 'none',
                  backgroundColor: '#F0F0F0',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  display: 'flex',
                  marginRight: '10px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'background 0.2s, box-shadow 0.2s',
                  boxShadow: '0 0 0 0 transparent',
                  '&:hover': {
                    boxShadow: '0 0 0 2px #e0e0e0',
                  },
                }}
                onClick={() => {
                  if (inputRef.current) {
                    inputRef.current.blur();
                  }

                  setSearchQuery(inputRef.current?.value || '');
                  refetch();
                }}
                tabIndex={0}
              >
                <Search sx={{ color: '#4C4C4C' }} />
              </Box>
            </InputAdornment>
          ),
        }}
      />


      {isFetching && (
        <Grid container spacing={'20px'} justifyContent="center" alignItems="center" sx={{ minHeight: '120px', marginBottom: '20px' }}>
          <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box><CircularProgress /></Box>
          </Grid>
          <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box><CircularProgress /></Box>
          </Grid>
          <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box><CircularProgress /></Box>
          </Grid>
        </Grid>
      )}

      <Stack flexDirection={'row'} gap={'20px'}>
        {        
          isFetched && !isFetching && <Grid container spacing={'30px'}>
            <Grid item sm={4}>
              <TableTermometroPedagogico
                type={'high'}
                data={filterData(summary?.high_students || [])}
              />
            </Grid>
            <Grid item sm={4}>
              <TableTermometroPedagogico
                type={'intermediary'}
                data={filterData(summary?.intermediary_students || [])}
              />
            </Grid>
            <Grid item sm={4}>
              <TableTermometroPedagogico
                type={'low'}
                data={filterData(summary?.low_students || [])} />
            </Grid>
          </Grid>
        }
      </Stack>

    </Box>
  </>);
};

export default TermometroPedagogico;
